
class SiteElementFavorite
    extends QueryElement<HTMLElement> {

    private readonly _site: Site;
    private readonly _id: string;

    constructor(element: HTMLElement, site: Site) {
        super(element);

        this._site = site;
        this._id = this.getAttr("data-id") ?? "";

        this.on("click", a => {
            this.click();
        });
    }

    isActive() {
        return this.containsClass("favorite-is-active");
    }

    async click() {

        let request = new QueryRequest(
            `/Favorites/${this.isActive() ? "Delete" : "Put"}/${this._id}`, {
            contentType: 'json',
            method: 'get'
        });

        await request.request();

        if (this.isActive()) {
            this.removeClass("favorite-is-active");
            this.addClass("favorite-is-inactive");
        } else {
            this.addClass("favorite-is-active");
            this.removeClass("favorite-is-inactive");
        }

        var favorites = this._site.getFavorites();
        if (favorites != null)
            await favorites.reload();
    }

}